import { GetApp } from "../../App"
import { BlockRow } from "../../Components/Block"
import { Icon, Icons } from "../../Components/Icon"
import { TabBar } from "../../Components/TabBar"
import { INoteParentType } from "../../Types"
import { NoteTabs } from "../NoteView"
import { StatsView } from "../StatsView"
import { TrackView } from "../TrackView"
import { CruiseEditView } from "./EditView"
import { CruiseDetailsViewProps } from "./Params"
import { useCruiseData } from "./DataContext"

export function CruiseDetailsView({ cruise, tracks, initTab, tabBarRef, onPrint }: CruiseDetailsViewProps) {
  const app = GetApp();
  const t = app.getT("CruiseView");
  const { writers } = useCruiseData();

  return (
    <div className="CruiseView-details">
      <TabBar defaultSelection={initTab || "cruise"} callbacks={tabBarRef} tabs={[
        { icon: Icons.Cruise, name: "cruise", title: t("tab_cruise"), render: () => {
          return <CruiseEditView cruise={cruise} />;
        } },
        { icon: Icons.Stats, name: "stats", title: t("tab_stats"), render: () => {
          return <StatsView cruise={cruise} calculate={writers.calculateCruise} />;
        } },
        { icon: Icons.Track, name: "track", title: t("tab_track"), render: () => {
          return (
            <div className="CruiseView-track">
              <TrackView fullscreen={false} tracks={tracks} timezone={app.status?.systemTimezone ?? 0} />
            </div>
          );
        } },
        ...(
          NoteTabs(app, INoteParentType.cruise, cruise.notes || [])
        ),
        { icon: Icons.Print, name: "print", title: t("tab_print"), render: () => {
          return (
            <div className="CruiseView-print-tab">
              <BlockRow className="block-row-button-print">
                <button className="button" onClick={onPrint}>
                  <Icon icon={Icons.Print} className="icon-large" /> {t("print_cruise")}
                </button>
              </BlockRow>
            </div>
          );
        } },
      ]}
      />
    </div>
  );
}
